/** Publication dates belong to the SK/CZ shop, not the visitor's machine timezone. */
export function formatBlogPublishedDate(value: string, locale: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const options = { timeZone: 'Europe/Bratislava' } as const;
  try {
    return date.toLocaleDateString(locale, options);
  } catch (error) {
    if (error instanceof RangeError) return date.toLocaleDateString('en-US', options);
    throw error;
  }
}
